/**
* @Author: zachalam
* @Date:   2017-02-07T15:43:50-08:00
* @Email:  zach@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-18T14:25:11-07:00
*/

import React, { Component, PropTypes } from 'react';
import { borders, type } from '../../style'
import { css, StyleSheet } from 'aphrodite/no-important';

const style = StyleSheet.create({
  textInput: {
    width: '100%',
    appearance: 'none',
    boxSizing: 'border-box',
    border: borders.DARKER,
    padding: '10px',
    outline: 'none',
    borderRadius: '3px',
    ...type.MD,

    ':focus': {
      border: borders.BRAND
    }
  },
  error: {
    borderColor: 'red'
  },
  errorText: {
    color: 'red',
    margin: '0'
  }
})


class LongText extends Component {
  render() {

    const {
      error,
      ...props
    } = this.props


    return (
      <div>
          {/* Username or Email */}
          <textarea className={css(style.textInput, (!!error) && style.error)} {...props}>
          </textarea>
      </div>
    );
  }
}

LongText.propTypes = {
  onChange: PropTypes.any.isRequired,
  value: PropTypes.string,
  error: PropTypes.any,
  placeholder: PropTypes.any
};


export default LongText;



// WEBPACK FOOTER //
// ./src/components/common/LongText.jsx